import { z } from 'zod';
import { ISODateSchema, UUIDSchema } from './common';
import { AppraiserLegacyUserSchema } from './user';
export const NewOrderNoteSchema = z.object({ title: z.string(), text: z.string() });
export const OrderNoteSchema = NewOrderNoteSchema.extend({
    id: UUIDSchema,
    order_uuid: UUIDSchema,
    updated_on: ISODateSchema,
    created_on: ISODateSchema,
    created_by: AppraiserLegacyUserSchema,
});
const OrderNotesShape = { notes: z.array(OrderNoteSchema) };
export const OrderNotesSchema = z.object(OrderNotesShape);
